import { render, staticRenderFns } from "./Supplier.vue?vue&type=template&id=21af4414&lang=pug&"
import script from "./Supplier.vue?vue&type=script&lang=ts&"
export * from "./Supplier.vue?vue&type=script&lang=ts&"
import style0 from "./Supplier.vue?vue&type=style&index=0&id=21af4414&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports